import * as actions from './actions';

const initialState = {
  count: 0,
  error: null,
  cards: [],
  initial: false,
  loading: false,

  // Anonymous per-reading purchase
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
};

export default function tarotCardsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_TAROT_CARDS_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.FETCH_TAROT_CARDS_SUCCESS:
      return { ...state, initial: true, count: action.payload.count, cards: action.payload.cards, loading: false, error: null };
    case actions.FETCH_TAROT_CARDS_FAILURE:
      return { ...state, initial: false, count: 0, loading: false, error: action.payload };

    case actions.CREATE_PENDING_THREECARD_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null };
    case actions.CREATE_PENDING_THREECARD_SUCCESS:
      return { ...state, pendingLoading: false, pendingReadingId: action.payload.readingId };
    case actions.CREATE_PENDING_THREECARD_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.TAROT_CHECKOUT_REQUEST:
    case actions.TAROT_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.TAROT_CHECKOUT_SUCCESS:
    case actions.TAROT_PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.TAROT_CHECKOUT_FAILURE:
    case actions.TAROT_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.TAROT_VERIFY_REQUEST:
    case actions.TAROT_VERIFY_PAYPAL_REQUEST:
      return { ...state, loading: true, checkoutError: null };
    case actions.TAROT_VERIFY_SUCCESS:
    case actions.TAROT_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        loading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
      };
    case actions.TAROT_VERIFY_FAILURE:
    case actions.TAROT_VERIFY_PAYPAL_FAILURE:
      return { ...state, loading: false, checkoutError: action.payload };

    default:
      return state;
  }
}
